import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

type AdditionalClassGroupIDs = 'text-typography' | 'text-color';

const twMerge = extendTailwindMerge<AdditionalClassGroupIDs>({
  override: {
    classGroups: {
      // Typography classes (size, weight, etc.) - should not conflict with colors
      'text-typography': [
        (value: string) =>
          value.startsWith('text-') &&
          !value.startsWith('text-text-') &&
          !value.startsWith('text-center') &&
          !value.startsWith('text-left') &&
          !value.startsWith('text-right') &&
          !value.startsWith('text-justify') &&
          !value.startsWith('text-add-'),
      ],
      // Color classes - separate group that doesn't conflict with typography
      'text-color': [(value: string) => value.startsWith('text-text-')],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
